import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

interface StickyDimensions {
    top?: number;
    bottom?: number;
    height?: number;
    index?: number;
    el?: any;
    indexObs?: BehaviorSubject<number>;
}

@Injectable()
export class StickyHeaderService {
    private readonly stickies: BehaviorSubject<StickyDimensions[]> =
        new BehaviorSubject<StickyDimensions[]>([]);

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    addSticky(el: any, elTableParent: any) {
        let s = this.stickies.getValue();

        let foundelement = null;
        s.forEach((h) => {
            if ($(h.el).is(el)) {
                foundelement = h.index;
            }
        });

        if (foundelement !== null) {
            return foundelement;
        }

        const offset = $(el).offset();
        const f = {
            top: offset.top,
            height: $(elTableParent).outerHeight(),
            index: s.length,
            el,
            indexObs: new BehaviorSubject<number>(s.length),
        };

        s.push(f);

        s = this.reorder(s);

        this.stickies.next(s);

        return f.index;
    }

    get stickyList(): Observable<StickyDimensions[]> {
        return this.stickies.asObservable();
    }

    indexObservable(currentIndex: number): Observable<number> {
        const f = this.stickies.getValue();
        const a = f.find((g) => g.index === currentIndex);
        return a.indexObs;
    }

    reorder(s: StickyDimensions[]): StickyDimensions[] {
        let idx = 0;
        s.sort((a, b) => a.top - b.top);
        return s.map((g) => {
            const t = $(g.el).closest('table');
            const top =
                $(t)[0].getBoundingClientRect().top + window.pageYOffset;
            // only recalculate the inner heights, not the outermost (which is always going to be first)
            if (g.index !== 0) {
                g.height = $(t).outerHeight();
            }
            g.index = idx;
            idx++;
            g.indexObs.next(g.index);
            g.top = top;
            return g;
        });
    }

    isInDescendantStickyDomain(idx: number, currentTop: number): boolean {
        let s = this.stickies.getValue();
        let indomain = false;
        s = s.filter((f) => f.index !== idx);

        s.forEach((g) => {
            if (indomain === false) {
                // when the current sticky header enters the bounds of another sticky header (have 65px pre-cut in the end, and 10px pre-cut in the beginning)
                if (idx === 0 && g.index > idx) {
                    indomain = this.isColliding(currentTop, g.top, g.height);
                } else if (idx < g.index && g.index !== 0) {
                    indomain = this.isColliding(currentTop, g.top, g.height);
                }
            }
        });
        return indomain;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    isColliding(currentTop: number, gtop: number, gheight: number) {
        return currentTop >= gtop - 35 && currentTop <= gtop + gheight - 45;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    removeFromStickyList(idx: number) {
        let s = this.stickies.getValue();
        s = s.filter((g) => g.index !== idx);
        this.stickies.next(s);
    }
}
